import(/* webpackMode: "eager" */ "/app/apps/fleet-ui/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/apps/fleet-ui/src/components/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/fleet-ui/src/components/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/apps/fleet-ui/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeColorProvider"] */ "/app/apps/fleet-ui/src/context/theme-color-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetaDataProvider"] */ "/app/apps/fleet-ui/src/contexts/metaData-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/alert-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/calendar.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/form.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/label.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/popover.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/select.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/switch.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"variable\":\"--font-poppins\",\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\"],\"display\":\"swap\",\"adjustFontFallback\":false}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Orbitron\",\"arguments\":[{\"variable\":\"--font-orbitron\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"display\":\"swap\"}],\"variableName\":\"orbitron\"}");
